module.exports = __webpack_public_path__ + "img/icon9.728ad02f.png";